import React, { useContext } from 'react';
import { SearchContext } from "../../context/SearchContext.js";
import { SettingsContext } from "../../context/SettingsContext.js";
import { isDisabledItem } from "../../functions/isDisabledItem.js";
import { useFavoriteItems } from "../../hooks/useFavoriteItems.js";
import { InlineLabel } from "../InlineLabel/InlineLabel.js";
import { Item } from "../Item/Item.js";
import { ItemDisabled } from "../Item/ItemDisabled.js";
import styles from "./ContextMenuColumnItems.module.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function ContextMenuColumnItems({
  level,
  items,
  isFiltered,
  favorites = []
}) {
  const {
    favoriteItems,
    otherItems
  } = useFavoriteItems(favorites, isFiltered, items);
  const {
    favoritesLabel
  } = useContext(SettingsContext);

  // use different index then the map index for the items (otherwise the index of disabled items will count as well)
  let favIndex = 0;
  let otherIndex = favoriteItems.length;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [favoriteItems.length > 0 && /*#__PURE__*/_jsx(InlineLabel, {
      children: favoritesLabel ?? 'Häufig verwendet'
    }), favoriteItems.map((o, i) => isDisabledItem(o) ? /*#__PURE__*/_jsx(ItemDisabled, {
      item: o
    }, o.key ?? i) : /*#__PURE__*/_jsx(Item, {
      item: o,
      previousFolderLabel: favoriteItems[i - 1]?.folderLabel,
      level: level,
      isFiltered: isFiltered,
      index: (() => favIndex++)()
    }, o.key ?? i)), favoriteItems.length > 0 && /*#__PURE__*/_jsx("hr", {
      className: styles.separator
    }), otherItems.map((o, i) => isDisabledItem(o) ? /*#__PURE__*/_jsx(ItemDisabled, {
      item: o
    }, o.key ?? i) : /*#__PURE__*/_jsx(Item, {
      item: o,
      previousFolderLabel: otherItems[i - 1]?.folderLabel,
      level: level,
      isFiltered: isFiltered,
      index: (() => otherIndex++)()
    }, o.key ?? i))]
  });
}
export function ContextMenuColumnItemsConnected(props) {
  const {
    filteredItems: items,
    isFiltered
  } = useContext(SearchContext);
  return /*#__PURE__*/_jsx(ContextMenuColumnItems, {
    ...props,
    items: items,
    isFiltered: isFiltered
  });
}